import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal} from 'antd'
import {QuestionCircleFilled, EditOutlined, DeleteOutlined} from '@ant-design/icons'
import FormModal from './FormModal'
import {withTranslation} from 'react-i18next'

const {confirm} = Modal

@inject('permissionManagementStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    record: null
  }

  componentDidMount() {
  }

  handleEdit = (record) => {
    const {permissionManagementStore} = this.props
    permissionManagementStore.onGetAction(record.id).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const {permissionManagementStore, t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        permissionManagementStore.onChangePageNo()
        permissionManagementStore.onDeletePermissionAction(record.id)
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {permissionManagementStore} = this.props
    permissionManagementStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const {permissionManagementStore, t} = this.props
    const {pageNo, pageSize, itemCount, permissionList, permissionType} = permissionManagementStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(permissionList)} pagination={pagination} rowClassName={this.getRowClassName} rowKey="id">
          <Table.Column width={80} title="ID" render={(text, record, index) => `${(pageNo - 1) * pageSize + (index + 1)}`}/>
          {permissionType === 'OPERATION' ? <>
            <Table.Column title={t(`permissionManagement.id"`)} dataIndex="id" key="id" ellipsis={true}/>
            <Table.Column title={t(`permissionManagement.permissionName`)} dataIndex="name" key="name" ellipsis={true}/>
            <Table.Column title={t(`permissionManagement.permissionKey`)} dataIndex="key" key="key" ellipsis={true}/>
          </> : permissionType === 'API' ? <>
            <Table.Column title={t(`permissionManagement.apiId`)} dataIndex="id" key="id" ellipsis={true}/>
            <Table.Column title={t(`permissionManagement.apiName`)} dataIndex="name" key="name" ellipsis={true}/>
            <Table.Column title={t(`permissionManagement.apiKey`)} dataIndex="key" key="key" ellipsis={true}/>
            <Table.Column title={t(`permissionManagement.requestMethod`)} dataIndex="method" key="method" ellipsis={true}/>
            <Table.Column title={t(`permissionManagement.requestPath`)} dataIndex="path" key="path" ellipsis={true}/></> : <>
            <Table.Column title={t(`permissionManagement.menuId`)} dataIndex="id" key="id" ellipsis={true}/>
            <Table.Column title={t(`permissionManagement.menuName`)} dataIndex="name" key="name" ellipsis={true}/>
            <Table.Column title={t(`permissionManagement.menuKey`)} dataIndex="key" key="key" ellipsis={true}/>
            <Table.Column title={t(`permissionManagement.parentId`)} dataIndex="parentId" key="parentId" ellipsis={true}/></>}
          <Table.Column align="center" title={t(`general.action`)} key="action" render={(text, record) => (
            <>
              <Button onClick={() => this.handleEdit(record)} type="link" icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
